import {
    SET_INTANGIBLE_CONTRACTS,
    SET_INTANGIBLE_VIEW,
    UPDATE_INTANGIBLE_FIELD
} from "../types";

const initialState = {
    data: {},
    lists: {},
    contacts: {},
    view: {}
};

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case UPDATE_INTANGIBLE_FIELD:
            return {
                ...state,
                data: payload
            };
        case SET_INTANGIBLE_VIEW:
            return {
                ...state,
                data: payload.data,
                contacts: payload.contacts,
                view: {
                    ...state.view,
                    skeleton: payload.skeleton,
                    dropdowns: payload.dropdowns,
                    validation_rules: payload.validation_rules
                }
            };
        case SET_INTANGIBLE_CONTRACTS:
            return {
                ...state,
                view: {
                    ...state.view,
                    dropdowns: {
                        ...state.view.dropdowns,
                        contracts: payload
                    }
                }
            };
        default:
            return state;
    }
}